import { Grid, Box, Typography } from '@mui/material';

const PlateSeason = ({ season, text }) => {
  return (
    <Grid
      sx={{ border: '5px solid #e7e7e7', borderRadius: '50%' }}
      container
      justifyContent="center"
      alignItems="center"
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          width: 60,
          height: 60,
          backgroundColor: season?.color2 || '#000',
          borderRadius: '50%',
        }}
      >
        <Typography
          sx={{
            color: season.text || '#000',
            fontSize: 10,
            fontWeight: 'bold',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Grid>
  );
};

export default PlateSeason;
